import { render, staticRenderFns } from "./CadastroAmostraMaterial.vue?vue&type=template&id=36e7d7ab&"
import script from "./CadastroAmostraMaterial.vue?vue&type=script&lang=js&"
export * from "./CadastroAmostraMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports